export const MINGCHUAN_WEBSITE_URL = 'https://mingchuan.ie/';
export const MINGCHUAN_QR_IMAGE = require('../../assets/mingchuan-website-qr.png');
export const DOWNLOAD_FILENAME = 'mingchuan-website-qr.png';
